

// exports.displayButtons = (tableRef) => {
//     const tableElement = window.$(tableRef.current);

//     if (tableElement) {
//         tableElement.DataTable().destroy();
//     }

//     const table = tableElement.DataTable({
//         responsive: true,
//         scrollX: true,
//         lengthChange: false,
//         buttons: ["copy", "excel", "pdf", "colvis"],
//     });

//     table.buttons()
//         .container()
//         .appendTo("#datatable-buttons_wrapper .col-md-6:eq(0)");

//     window.$(".dataTables_length select").addClass("form-select form-select-sm");

// }

exports.displayButtons = (tableRef, data) => {
    const tableElement = window.$(tableRef.current);

    if (!window.$.fn.DataTable.isDataTable(tableElement)) {

        const table = tableElement.DataTable({
            responsive: true,
            scrollX: true,
            lengthChange: false,
            ordering: false,
            buttons: ["copy", "excel", "pdf", "colvis"],
        });

        table.buttons()
            .container()
            .appendTo("#datatable-buttons_wrapper .col-md-6:eq(0)");

        window.$(".dataTables_length select").addClass("form-select form-select-sm");

        if (data?.length > 0) {
            data.forEach(row => table.row.add(row));
            table.draw();
        }
    } else {
        const table = tableElement.DataTable();
        table.clear();
        if (data?.length > 0) {
            data.forEach(row => table.row.add(row));
        }
        table.draw();
    }
};
